import { AfterContentChecked, ChangeDetectorRef, Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { AuthService } from '../../services/auth.service';
import { ShuttelbussService } from '../../services/shuttlebuss.service';
import { SnackbarService } from '../../services/snackbar.service';
import { TranslocoService } from '@jsverse/transloco';

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const invalidCtrl = !!(control && control.invalid && control.parent.dirty);
    const invalidParent = !!(
      control &&
      control.parent &&
      control.parent.invalid &&
      control.parent.dirty
    );

    return invalidCtrl || invalidParent;
  }
}

@Component({
  selector: 'app-my-settings',
  templateUrl: './my-settings.component.html',
  styleUrls: ['./my-settings.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class MySettingsComponent implements OnInit, AfterContentChecked {
  showDetails: boolean;
  matcher = new MyErrorStateMatcher();
  passwordMatchError = false;
  mobileNumberForm: UntypedFormGroup;
  changePasswordForm: UntypedFormGroup;
  user: any;
  phonenumber: any;
  activeLang: string = 'sv';
  passwordLabels = {
    en: 'Change Password',
    sv: 'Byt lösenord'
  };
  phoneNumberLabels = {
    en: 'Add phone number',
    sv: 'Lägg till telefonnummer'
  };

  constructor(
    public authService: AuthService,
    private cdref: ChangeDetectorRef,
    public snackBar: SnackbarService,
    public shuttelbussService: ShuttelbussService,
    public translate: TranslocoService
  ) { }

  ngOnInit(): void {
    this.getUser();
    this.changePasswordForm = new UntypedFormGroup({
      oldPassword: new UntypedFormControl('', Validators.required),
      newPassword: new UntypedFormControl('', [Validators.required, Validators.minLength(8)]),
      confirmedPassword: new UntypedFormControl('', [Validators.required, Validators.minLength(8)])
    });
    this.mobileNumberForm = new UntypedFormGroup({
      mobile: new UntypedFormControl('', [Validators.required, Validators.minLength(10)])
    });
    this.activeLang = this.translate.getActiveLang();

    this.translate.langChanges$.subscribe((lang) => {
      this.activeLang = lang;
    });
  }

  getUser() {
    this.shuttelbussService.loadMyPageData().subscribe(user => {
      console.log(user)
      this.user = user;
      this.phonenumber = this.user.mobile;
    });
  }

  changePhoneNumber() {
    const newPhonenumber = this.mobileNumberForm.controls['mobile'].value;
    this.user.mobile = newPhonenumber;
    this.shuttelbussService.saveMyPageData(this.user).subscribe(result => {
      this.snackBar.openSnackBar(`Du har angett telefonnummer ${newPhonenumber}`, 'OK');
    });
  }

  public changePassword() {
    const oldPassword: string = this.changePasswordForm.controls['oldPassword'].value;
    const confirmedPassword: string = this.changePasswordForm.controls['confirmedPassword'].value;
    const newPassword: string = this.changePasswordForm.controls['newPassword'].value;
    const model = {
      site: 'www.shuttlebuss.se',
      oldpassword: oldPassword,
      newpassword: newPassword
    };
    if (oldPassword && confirmedPassword !== newPassword) {
      this.snackBar.openSnackBar(newPassword, 'OK');
    } else {
      this.shuttelbussService.changePassword(model).subscribe(result => {
        if (result.status === 8) {
          this.snackBar.openSnackBar('Lösenordet är ändrat', 'OK');
          this.changePasswordForm.reset();
        }
        if (!result.success && result.status === 25) {
          this.snackBar.openSnackBar('Fel lösenord, försök igen...', 'OK');
          this.changePasswordForm.reset();
        } else if (!result.success && result.status === 21) {
          this.snackBar.openSnackBar('Lösenordet är för svagt, försök igen...', 'OK');
        } else {
          this.changePasswordForm.reset();
        }
      });
    }
  }

  ngAfterContentChecked() {
    this.cdref.detectChanges();
  }

  onStrengthChanged(strength: number) {
    console.log('password strength = ', strength);
  }
}
